<form [formGroup]="form" *ngIf="dataEntity">
  <div class="form-row">
    <div class="switch">
      <label>
        <input
          type="checkbox"
          formControlName="allowEdit"
          [(ngModel)]="dataEntity.allowEdit"
        />
        Allow Editing
      </label>
    </div>
    <small class="form-text text-muted w-100">
      When enabled, users can modify the issue date when completing the form activity.
    </small>
  </div>
  <div class="form-row mt-2">
    <div class="switch">
      <label>
        <input
          type="checkbox"
          formControlName="visibleToUser"
          [(ngModel)]="dataEntity.visibleToUser"
        />
        Visible To User
      </label>
    </div>
  </div>
  <div class="form-row mt-3" *ngIf="dataEntity && dataEntity.allowEditFormula">
    <div class="col-12">
      <p class="text-muted small mb-1">
        <strong>Conditional Date Formula</strong> — configure conditions that calculate the issue date.
        When no condition matches (or no conditions are configured), today's date is used automatically.
      </p>
      <wm-data-entity-formula
        id="formula"
        [form]="form"
        [workflow]="workflow"
        [activity]="activity"
        [criteria]="dataEntity.formulaCriteria"
        [thenLabelGetter]="getThenLabel"
        (criteriaChanged)="updateCriteria($event)"
        [formulaTitle]="'formula'"
      ></wm-data-entity-formula>
    </div>
  </div>
</form>
